module.exports = __webpack_public_path__ + "static/solutions_page_graphics-38caa2cc9f457fd6e12d82f100292d85.png";